<template>
  <div class='buttons pbbButtons'>
    <div product>
        <img :src="ProductImage"/>
        <ul v-for="(row,index) in KeyMap" :line='index'>
            <el-tooltip v-for="(item,i) in row" :key="i" manual :ref="'tooltip-' + item.index" class="item" effect="dark" :content="$t('msg.tooltip')" placement="top">
                <li :class='{"on": curIndex === item.index , "has": item.custom.name != item.key_name && item.custom.name != ""}' @click="addClassOn(item.index)" fn="1" isset="1" j="0" r="0" c="0" v-if="item.key_name" :cname="item.name"  :name="item.key_name">
                    
                    <i class="el-icon-circle-check"></i>
                    <i style="background-color: transparent; opacity: 0.5;"></i>
                    <div box>
                            <h2>{{item.custom.type}}</h2>
                            <p>{{item.custom.name}}</p>
                    </div>
                </li>
            </el-tooltip>
        </ul>
    </div>

  </div>
</template>
<script>


import $ from 'jquery'

export default {
  name: 'pBButtonC',
  components: 
  {

  },
  data() {

    return {
      HIDDeviceObj:null,
      KeyMap: [],
      indexes:0,
      curIndex:-1,
      showTooltip: false,
      clickId: '',
      ProductImage:null
    }
  },
  mounted() 
  { 
      setTimeout(()=>
      {
        this.AutoButtonBGXY();
      },2000);
      
  },
  created() 
  {
	document.addEventListener('dblclick', this.handleClick);
  },
  updated()
  {

    
  },
  methods: 
  {
    init()
    {

    },
    //获取设备图片
    setProductImagePath()
    {
        this.ProductImage = require("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/image/product_k.png");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/keyboard.css");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/buttonBGXY.css");
    },
    // 点击其它地方隐藏tooltip
	handleClick() 
    {
        if(this.clickId>-1)
        {
            this.$refs[`${'tooltip-' + this.curIndex}`][0].showPopper = false;
            this.clickId = -1;
            this.curIndex = -1;
        }
    },
    addClassOn(index)
    {
        // if(this.$refs[`${'tooltip-' + index}`][0].$el.getAttribute("name")== "FN")
        // {
        //     this.$message({message:this.$i18n.t("msg.FNMody"),type: 'warning',center: true,offset:500,duration:1000});
        //     return false;
        // }

        if(this.curIndex>-1)
        {
            this.$refs[`${'tooltip-' + this.curIndex}`][0].showPopper = false;
        }
        
        this.curIndex = index;
        this.clickId  = index;
        // 只切换当前的tooltip显示/隐藏
        this.$refs[`${'tooltip-' + index}`][0].showPopper = true;
        setTimeout(()=>{this.$refs[`${'tooltip-' + index}`][0].showPopper = false;},1000);

    },
    downloadCSS(content) 
    {
        // 创建一个Blob实例，类型为CSS
        const blob = new Blob([content], { type: 'text/css' });
        // 创建一个指向Blob的URL
        const url = URL.createObjectURL(blob);
        // 创建一个a标签
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'style.css');
        document.body.appendChild(link);
        // 触发下载
        link.click();
        // 清理
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    },
    AutoButtonBGXY()
    {
        var content = this;
        $(".pbbButtons").keydown(function(event) 
        {
            var $objKey = $(".pbbButtons li.on");

            //生成CSS
            if(event.keyCode == 13) {

                var cssStyle = "";
                $(".buttonTabC .buttons").find("li").each(function(index,key)
                {

                    var name = $(this).attr("name");
                        name = name == "\\"?"\\\\":name;

                    var BPX = $(this).css("background-position-x");
                    var BPY = $(this).css("background-position-y");

                    var BPW = $(this).css("width");
                    var BPH = $(this).css("height");
                    var BPML = $(this).css("margin-left");
                    var curCss = '.buttons [name="'+name+'"] {margin-left:'+BPML+';width:'+BPW+';height:' + BPH +';background-position-x: '+ BPX +' !important;background-position-y: '+BPY+' !important;}\n';

                    cssStyle+=curCss;
                });


                content.downloadCSS(cssStyle);
                // console.log(cssStyle);

                }

            //宽+
            if(event.keyCode == 187) {

            var $objKey = $(".pbbButtons li.on");

            var BPW =  $objKey.css("width");
            BPW = BPW.replace("\%","");
            BPW = BPW.replace("px","");
            BPW = parseInt(BPW)+1;
            $objKey.css({
                "width": BPW+"px"
            });
            }

            //宽-
            if(event.keyCode == 189) {

            var $objKey = $(".pbbButtons li.on");

            var BPW =  $objKey.css("width");
            BPW = BPW.replace("\%","");
            BPW = BPW.replace("px","");
            BPW = parseInt(BPW)-1;
            $objKey.css({
                "width": BPW+"px"
            });
            }

            //margin-left+
            if(event.keyCode == 76) {

            var $objKey = $(".pbbButtons li.on");

            var BPW =  $objKey.css("margin-left");
            BPW = BPW.replace("\%","");
            BPW = BPW.replace("px","");
            BPW = parseInt(BPW)+1;

            $objKey.css('cssText',"margin-left:"+ BPW +"px");
            }
            //margin-left-
            if(event.keyCode == 82) {

            var $objKey = $(".pbbButtons li.on");
            var BPW =  $objKey.css("margin-left");

            BPW = BPW.replace("\%","");
            BPW = BPW.replace("px","");
            BPW = parseInt(BPW)-1;

            $objKey.css('cssText',"margin-left:"+ BPW +"px !important");
            }

        });
    }
  },
  computed: 
  {

    
  }
}
</script>